import {
  CustomShiftFlag3j9rrshyn9z40 as CustomShiftFlag,
  ICustomShiftFlagAccessor21oxot5gxdn5a as ICustomShiftFlagAccessor,
  ICustomShiftFlagMutator1702xc1l2rf9w as ICustomShiftFlagMutator,
  IScheduleWarningAccessor3mhssfafpp187 as IScheduleWarningAccessor,
} from './Shared7Punches-domain-scheduling-domain.mjs';
import {
  nullIfZeroqaja8qzkwg8f as nullIfZero,
  ApiVersion_JULY_2026_getInstance26s1g5r9ct27x as ApiVersion_JULY_2026_getInstance,
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  ApiVersion_FEBRUARY_2026_getInstancexhgc3m6uvy4r as ApiVersion_FEBRUARY_2026_getInstance,
  ApiPaginatedResponse21k9qwv83e5dh as ApiPaginatedResponse,
  Clientssjxb7gh2u6y as Client,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Long2qws0ah9gnpki as Long,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  Unit_instance104q5opgivhr8 as Unit_instance,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  equals2au1ep9vhcato as equals,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  Result3t1vadv16kmzk as Result,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  KtList3hktaavzmj137 as KtList,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  emptyList1g2z5xcrvp2zy as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  get_nullable197rfua9r7fsz as get_nullable,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  SimpleListEndpointCacheStrategy1m0xsspwu4sws as SimpleListEndpointCacheStrategy,
  Companion_instance38at02i5wbrbj as Companion_instance_0,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  Unknown1xcq5nwq6ckcn as Unknown,
  IListLocalSource39ga4nlfbxuv1 as IListLocalSource,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  SimpleListCacheLocalSource9ig3nhg8ocnr as SimpleListCacheLocalSource,
} from './Shared7Punches-common-base.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
} from './ktor-ktor-client-ktor-client-core.mjs';
import { Companion_getInstancepumzx9q4106p as Companion_getInstance_0 } from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  TypeQualifier1esmq2h0dalsb as TypeQualifier,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  binds4rk2rn2wwzpn as binds,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { IShiftInvalidator3ba6keaeoutnl as IShiftInvalidator } from './Shared7Punches-domain-shift-domain.mjs';
import { ICache3bwileb79diof as ICache } from './Shared7Punches-infrastructure-cache.mjs';
import {
  IDepartmentAccessor2hj1il6ko3wqn as IDepartmentAccessor,
  ILocationAccessor2jiwvdkvuuw23 as ILocationAccessor,
} from './Shared7Punches-data-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiCustomShiftFlag, 'ApiCustomShiftFlag', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiTemplate, 'ApiTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForLambda(CustomShiftFlagRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(CustomShiftFlagRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForClass(CustomShiftFlagRepository, 'CustomShiftFlagRepository', VOID, VOID, [ICustomShiftFlagAccessor, ICustomShiftFlagMutator], [1, 2, 0]);
initMetadataForClass(ScheduleWarningRepository, 'ScheduleWarningRepository', VOID, VOID, [IScheduleWarningAccessor], [1]);
initMetadataForInterface(ISchedulingMutator, 'ISchedulingMutator', VOID, VOID, VOID, [1]);
initMetadataForClass(SchedulingRepository, 'SchedulingRepository', VOID, VOID, [ISchedulingMutator], [1]);
initMetadataForLambda(TemplateRepository$cacheStrategy$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(TemplateRepository$cacheStrategy$slambda_1, CoroutineImpl, VOID, [0]);
initMetadataForInterface(ITemplateMutator, 'ITemplateMutator', VOID, VOID, VOID, [1, 2]);
initMetadataForInterface(ITemplateAccessor, 'ITemplateAccessor');
initMetadataForClass(TemplateRepository, 'TemplateRepository', VOID, VOID, [ITemplateMutator, ITemplateAccessor], [1, 2, 0]);
initMetadataForCompanion(Companion_1);
initMetadataForCoroutine($listCustomShiftFlagsCOROUTINE$11, CoroutineImpl);
initMetadataForCoroutine($getBasePathCOROUTINE$15, CoroutineImpl);
initMetadataForInterface(ICustomShiftFlagRemoteSource, 'ICustomShiftFlagRemoteSource', VOID, VOID, VOID, [0, 1, 2]);
initMetadataForClass(CustomShiftFlagRemoteSource, 'CustomShiftFlagRemoteSource', VOID, VOID, [ICustomShiftFlagRemoteSource], [0, 1, 2]);
initMetadataForInterface(IScheduleWarningRemoteSource, 'IScheduleWarningRemoteSource', VOID, VOID, VOID, [1]);
initMetadataForInterface(ISchedulingRemoteSource, 'ISchedulingRemoteSource', VOID, VOID, VOID, [2, 1]);
initMetadataForInterface(ITemplateRemoteSource, 'ITemplateRemoteSource', VOID, VOID, VOID, [1, 2, 0]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(ScheduleWarningRemoteSource, 'ScheduleWarningRemoteSource', VOID, VOID, [IScheduleWarningRemoteSource], [1]);
initMetadataForClass(SchedulingRemoteSource, 'SchedulingRemoteSource', VOID, VOID, [ISchedulingRemoteSource], [2, 1]);
initMetadataForCompanion(Companion_3);
initMetadataForCoroutine($listTemplatesCOROUTINE$25, CoroutineImpl);
initMetadataForCoroutine($getBasePathCOROUTINE$26, CoroutineImpl);
initMetadataForClass(TemplateRemoteSource, 'TemplateRemoteSource', VOID, VOID, [ITemplateRemoteSource], [1, 2, 0]);
initMetadataForInterface(ITemplateCompositeAccessor, 'ITemplateCompositeAccessor');
initMetadataForClass(Template, 'Template');
initMetadataForClass(TemplateCompositeService, 'TemplateCompositeService', VOID, VOID, [ITemplateCompositeAccessor]);
//endregion
function toDomain(_this__u8e3s4) {
  return new CustomShiftFlag(_this__u8e3s4.i8d_1, _this__u8e3s4.j8d_1, _this__u8e3s4.k8d_1);
}
function toDomain_0(_this__u8e3s4) {
  return new Template(_this__u8e3s4.l8d_1, _this__u8e3s4.m8d_1, nullIfZero(_this__u8e3s4.n8d_1), _this__u8e3s4.o8d_1);
}
function Companion() {
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.scheduling.data.model.ApiCustomShiftFlag', this, 3);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('name', false);
  tmp0_serialDesc.wy('color', false);
  this.p8d_1 = tmp0_serialDesc;
}
protoOf($serializer).q8d = function (encoder, value) {
  var tmp0_desc = this.p8d_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.i8d_1);
  tmp1_output.zs(tmp0_desc, 1, value.j8d_1);
  tmp1_output.zs(tmp0_desc, 2, value.k8d_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.q8d(encoder, value instanceof ApiCustomShiftFlag ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.p8d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = null;
  var tmp6_local2 = null;
  var tmp7_input = decoder.kr(tmp0_desc);
  if (tmp7_input.as()) {
    tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp7_input.ur(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp7_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp7_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp7_input.ur(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp7_input.ur(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp7_input.lr(tmp0_desc);
  return ApiCustomShiftFlag_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
};
protoOf($serializer).xn = function () {
  return this.p8d_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiCustomShiftFlag_init_$Init$(seen0, id, name, color, serializationConstructorMarker, $this) {
  if (!(7 === (7 & seen0))) {
    throwMissingFieldException(seen0, 7, $serializer_getInstance().p8d_1);
  }
  $this.i8d_1 = id;
  $this.j8d_1 = name;
  $this.k8d_1 = color;
  return $this;
}
function ApiCustomShiftFlag_init_$Create$(seen0, id, name, color, serializationConstructorMarker) {
  return ApiCustomShiftFlag_init_$Init$(seen0, id, name, color, serializationConstructorMarker, objectCreate(protoOf(ApiCustomShiftFlag)));
}
function ApiCustomShiftFlag(id, name, color) {
  this.i8d_1 = id;
  this.j8d_1 = name;
  this.k8d_1 = color;
}
protoOf(ApiCustomShiftFlag).toString = function () {
  return 'ApiCustomShiftFlag(id=' + this.i8d_1.toString() + ', name=' + this.j8d_1 + ', color=' + this.k8d_1 + ')';
};
protoOf(ApiCustomShiftFlag).hashCode = function () {
  var result = this.i8d_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.j8d_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.k8d_1) | 0;
  return result;
};
protoOf(ApiCustomShiftFlag).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiCustomShiftFlag))
    return false;
  var tmp0_other_with_cast = other instanceof ApiCustomShiftFlag ? other : THROW_CCE();
  if (!this.i8d_1.equals(tmp0_other_with_cast.i8d_1))
    return false;
  if (!(this.j8d_1 === tmp0_other_with_cast.j8d_1))
    return false;
  if (!(this.k8d_1 === tmp0_other_with_cast.k8d_1))
    return false;
  return true;
};
function Companion_0() {
}
var Companion_instance_2;
function Companion_getInstance_3() {
  return Companion_instance_2;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.scheduling.data.model.ApiTemplate', this, 4);
  tmp0_serialDesc.wy('id', false);
  tmp0_serialDesc.wy('location_id', false);
  tmp0_serialDesc.wy('department_id', false);
  tmp0_serialDesc.wy('name', false);
  this.r8d_1 = tmp0_serialDesc;
}
protoOf($serializer_0).s8d = function (encoder, value) {
  var tmp0_desc = this.r8d_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.vs(tmp0_desc, 0, value.l8d_1);
  tmp1_output.vs(tmp0_desc, 1, value.m8d_1);
  tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.n8d_1);
  tmp1_output.zs(tmp0_desc, 3, value.o8d_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.s8d(encoder, value instanceof ApiTemplate ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.r8d_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = new Long(0, 0);
  var tmp5_local1 = new Long(0, 0);
  var tmp6_local2 = null;
  var tmp7_local3 = null;
  var tmp8_input = decoder.kr(tmp0_desc);
  if (tmp8_input.as()) {
    tmp4_local0 = tmp8_input.qr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp8_input.qr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp8_input.ur(tmp0_desc, 3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp8_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp8_input.qr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp8_input.qr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp8_input.yr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp8_input.ur(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp8_input.lr(tmp0_desc);
  return ApiTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
};
protoOf($serializer_0).xn = function () {
  return this.r8d_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance()];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function ApiTemplate_init_$Init$(seen0, id, locationId, departmentId, name, serializationConstructorMarker, $this) {
  if (!(15 === (15 & seen0))) {
    throwMissingFieldException(seen0, 15, $serializer_getInstance_0().r8d_1);
  }
  $this.l8d_1 = id;
  $this.m8d_1 = locationId;
  $this.n8d_1 = departmentId;
  $this.o8d_1 = name;
  return $this;
}
function ApiTemplate_init_$Create$(seen0, id, locationId, departmentId, name, serializationConstructorMarker) {
  return ApiTemplate_init_$Init$(seen0, id, locationId, departmentId, name, serializationConstructorMarker, objectCreate(protoOf(ApiTemplate)));
}
function ApiTemplate(id, locationId, departmentId, name) {
  this.l8d_1 = id;
  this.m8d_1 = locationId;
  this.n8d_1 = departmentId;
  this.o8d_1 = name;
}
protoOf(ApiTemplate).toString = function () {
  return 'ApiTemplate(id=' + this.l8d_1.toString() + ', locationId=' + this.m8d_1.toString() + ', departmentId=' + toString(this.n8d_1) + ', name=' + this.o8d_1 + ')';
};
protoOf(ApiTemplate).hashCode = function () {
  var result = this.l8d_1.hashCode();
  result = imul(result, 31) + this.m8d_1.hashCode() | 0;
  result = imul(result, 31) + (this.n8d_1 == null ? 0 : this.n8d_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.o8d_1) | 0;
  return result;
};
protoOf(ApiTemplate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiTemplate))
    return false;
  var tmp0_other_with_cast = other instanceof ApiTemplate ? other : THROW_CCE();
  if (!this.l8d_1.equals(tmp0_other_with_cast.l8d_1))
    return false;
  if (!this.m8d_1.equals(tmp0_other_with_cast.m8d_1))
    return false;
  if (!equals(this.n8d_1, tmp0_other_with_cast.n8d_1))
    return false;
  if (!(this.o8d_1 === tmp0_other_with_cast.o8d_1))
    return false;
  return true;
};
function getRemoteData($this, $completion) {
  var tmp = $this.t8d_1.w8d($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
}
function CustomShiftFlagRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.f8e_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda).h8e = function (it, $completion) {
  var tmp = this.i8e(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.h8e((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.f8e_1.u8d_1.m2u(this.g8e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda).i8e = function (it, completion) {
  var i = new CustomShiftFlagRepository$cacheStrategy$slambda(this.f8e_1, completion);
  i.g8e_1 = it;
  return i;
};
function CustomShiftFlagRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new CustomShiftFlagRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.h8e(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function CustomShiftFlagRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.r8e_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda_1).s8e = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.s8e($completion);
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = getRemoteData(this.r8e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(CustomShiftFlagRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new CustomShiftFlagRepository$cacheStrategy$slambda_1(this.r8e_1, completion);
};
function CustomShiftFlagRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new CustomShiftFlagRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.s8e($completion);
  };
  l.$arity = 0;
  return l;
}
function CustomShiftFlagRepository$cacheStrategy$lambda(it) {
  return toDomain(it);
}
function CustomShiftFlagRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.f8d_1;
}
function CustomShiftFlagRepository(remoteSource, localSource) {
  this.t8d_1 = remoteSource;
  this.u8d_1 = localSource;
  var tmp = this;
  var tmp_0 = this.u8d_1.n18();
  var tmp_1 = CustomShiftFlagRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = CustomShiftFlagRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = CustomShiftFlagRepository$cacheStrategy$lambda;
  tmp.v8d_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, CustomShiftFlagRepository$cacheStrategy$lambda_0);
}
function ScheduleWarningRepository(remoteSource) {
  this.t8e_1 = remoteSource;
}
function SchedulingRepository(sessionDataProvider, remoteSource, shiftInvalidator) {
  this.u8e_1 = sessionDataProvider;
  this.v8e_1 = remoteSource;
  this.w8e_1 = shiftInvalidator;
}
function getRemoteData_0($this, $completion) {
  var tmp = $this.x8e_1.a8f($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    return tmp;
  return tmp;
}
function TemplateRepository$cacheStrategy$slambda(this$0, resultContinuation) {
  this.j8f_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TemplateRepository$cacheStrategy$slambda).l8f = function (it, $completion) {
  var tmp = this.m8f(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(TemplateRepository$cacheStrategy$slambda).h9 = function (p1, $completion) {
  return this.l8f((!(p1 == null) ? isInterface(p1, KtList) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(TemplateRepository$cacheStrategy$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.j8f_1.y8e_1.m2u(this.k8f_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(TemplateRepository$cacheStrategy$slambda).m8f = function (it, completion) {
  var i = new TemplateRepository$cacheStrategy$slambda(this.j8f_1, completion);
  i.k8f_1 = it;
  return i;
};
function TemplateRepository$cacheStrategy$slambda_0(this$0, resultContinuation) {
  var i = new TemplateRepository$cacheStrategy$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.l8f(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function TemplateRepository$cacheStrategy$slambda_1(this$0, resultContinuation) {
  this.v8f_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(TemplateRepository$cacheStrategy$slambda_1).w8f = function ($completion) {
  var tmp = this.m32($completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(TemplateRepository$cacheStrategy$slambda_1).ma = function ($completion) {
  return this.w8f($completion);
};
protoOf(TemplateRepository$cacheStrategy$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = getRemoteData_0(this.v8f_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(TemplateRepository$cacheStrategy$slambda_1).m32 = function (completion) {
  return new TemplateRepository$cacheStrategy$slambda_1(this.v8f_1, completion);
};
function TemplateRepository$cacheStrategy$slambda_2(this$0, resultContinuation) {
  var i = new TemplateRepository$cacheStrategy$slambda_1(this$0, resultContinuation);
  var l = function ($completion) {
    return i.w8f($completion);
  };
  l.$arity = 0;
  return l;
}
function TemplateRepository$cacheStrategy$lambda(it) {
  return toDomain_0(it);
}
function TemplateRepository$cacheStrategy$lambda_0($this$SimpleListEndpointCacheStrategy) {
  return $this$SimpleListEndpointCacheStrategy.x8f_1;
}
function TemplateRepository(remoteSource, localSource) {
  this.x8e_1 = remoteSource;
  this.y8e_1 = localSource;
  var tmp = this;
  var tmp_0 = this.y8e_1.n18();
  var tmp_1 = TemplateRepository$cacheStrategy$slambda_0(this, null);
  var tmp_2 = TemplateRepository$cacheStrategy$slambda_2(this, null);
  var tmp_3 = TemplateRepository$cacheStrategy$lambda;
  tmp.z8e_1 = new SimpleListEndpointCacheStrategy(tmp_0, tmp_1, tmp_2, tmp_3, TemplateRepository$cacheStrategy$lambda_0);
}
function getBasePath($this, $completion) {
  var tmp = new $getBasePathCOROUTINE$15($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function Companion_1() {
  Companion_instance_3 = this;
  this.k8g_1 = ApiVersion_JULY_2026_getInstance();
}
var Companion_instance_3;
function Companion_getInstance_4() {
  if (Companion_instance_3 == null)
    new Companion_1();
  return Companion_instance_3;
}
function CustomShiftFlagRemoteSource$listCustomShiftFlags$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function CustomShiftFlagRemoteSource$listCustomShiftFlags$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function $listCustomShiftFlagsCOROUTINE$11(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.t8g_1 = _this__u8e3s4;
}
protoOf($listCustomShiftFlagsCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.u8g_1 = this.t8g_1.m8i_1;
          this.n8_1 = 1;
          suspendResult = getBasePath(this.t8g_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.v8g_1 = suspendResult;
          var tmp_1 = this;
          tmp_1.w8g_1 = Companion_getInstance_4().k8g_1;
          this.x8g_1 = this.u8g_1;
          this.y8g_1 = this.v8g_1;
          this.z8g_1 = this.w8g_1;
          var tmp_2 = this;
          tmp_2.a8h_1 = CustomShiftFlagRemoteSource$listCustomShiftFlags$lambda;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.c8h_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.d8h_1 = this.x8g_1.f6l_1;
          var tmp_5 = this;
          tmp_5.e8h_1 = buildV2Path(this.x8g_1, this.y8g_1);
          this.f8h_1 = this.d8h_1;
          this.g8h_1 = this.e8h_1;
          var tmp_6 = this;
          tmp_6.h8h_1 = this.f8h_1;
          this.i8h_1 = this.h8h_1;
          var tmp_7 = this;
          tmp_7.j8h_1 = this.i8h_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.g8h_1);
          headers(this_0, CustomShiftFlagRemoteSource$listCustomShiftFlags$lambda_0(this.z8g_1));
          this_0.z5n(this.a8h_1);
          tmp_8.k8h_1 = this_0;
          this.l8h_1 = this.j8h_1;
          this.m8h_1 = this.k8h_1;
          this.m8h_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_9 = this;
          tmp_9.n8h_1 = this.l8h_1;
          var tmp_10 = this;
          tmp_10.o8h_1 = this.m8h_1;
          this.p8h_1 = this.n8h_1;
          this.q8h_1 = this.o8h_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.q8h_1, this.p8h_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.r8h_1 = suspendResult;
          var tmp_11 = this;
          this.c8h_1;
          var value = this.r8h_1;
          tmp_11.b8h_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.s8h_1 = this.q8_1;
            var tmp_13 = this;
            throw this.s8h_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.t8h_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.t8h_1;
              tmp_15.b8h_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.u8h_1 = this.b8h_1;
          this.v8h_1 = this.u8h_1;
          this.w8h_1 = Result__exceptionOrNull_impl_p6xea9(this.v8h_1);
          if (this.w8h_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.v8h_1);
            tmp_16.y8h_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.z8h_1 = this.y8h_1;
            var tmp_18 = this;
            tmp_18.a8i_1 = this.z8h_1;
            this.b8i_1 = this.a8i_1;
            this.c8i_1 = this.b8i_1.c4u().z43_1;
            var containsArg = this.c8i_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.f8i_1 = Companion_instance;
              if (getKClass(KtList).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.h8i_1 = this.b8i_1;
                this.i8i_1 = this.h8i_1;
                this.n8_1 = 7;
                var tmp_21 = this.i8i_1.y4u();
                var tmp_22 = getKClass(KtList);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiCustomShiftFlag), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.j8i_1 = this.b8i_1;
                this.k8i_1 = this.j8i_1;
                this.n8_1 = 6;
                var tmp_26 = this.k8i_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.l8i_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.b8i_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.w8h_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_31.x8h_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.l8i_1;
          tmp_32.d8i_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiCustomShiftFlag), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.g8i_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.g8i_1 = (!(suspendResult == null) ? isInterface(suspendResult, KtList) : false) ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.g8i_1;
          var tmp_37 = this;
          this.f8i_1;
          tmp_37.e8i_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.e8i_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.e8i_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.d8i_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.x8h_1 = new Result(this.d8i_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.x8h_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $getBasePathCOROUTINE$15(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.j8g_1 = _this__u8e3s4;
}
protoOf($getBasePathCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.j8g_1.n8i_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0 + '/custom_shift_flags';
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function CustomShiftFlagRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_4();
  this.m8i_1 = apiClient;
  this.n8i_1 = sessionDataProvider;
}
protoOf(CustomShiftFlagRemoteSource).w8d = function ($completion) {
  var tmp = new $listCustomShiftFlagsCOROUTINE$11(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function ICustomShiftFlagRemoteSource() {
}
function IScheduleWarningRemoteSource() {
}
function ISchedulingRemoteSource() {
}
function ITemplateRemoteSource() {
}
function Companion_2() {
  Companion_instance_4 = this;
  this.o8i_1 = ApiVersion_JULY_2026_getInstance();
}
var Companion_instance_4;
function Companion_getInstance_5() {
  if (Companion_instance_4 == null)
    new Companion_2();
  return Companion_instance_4;
}
function ScheduleWarningRemoteSource(apiClient) {
  Companion_getInstance_5();
  this.p8i_1 = apiClient;
}
function SchedulingRemoteSource(apiClient, sessionDataProvider) {
  this.q8i_1 = apiClient;
  this.r8i_1 = sessionDataProvider;
}
function Companion_3() {
  Companion_instance_5 = this;
  this.s8i_1 = ApiVersion_FEBRUARY_2026_getInstance();
}
var Companion_instance_5;
function Companion_getInstance_6() {
  if (Companion_instance_5 == null)
    new Companion_3();
  return Companion_instance_5;
}
function TemplateRemoteSource$listTemplates$lambda(_this__u8e3s4, it) {
  return Unit_instance;
}
function TemplateRemoteSource$listTemplates$lambda_0($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function TemplateRemoteSource$listTemplates$lambda_1($cursor, $itemsPerPage, $block) {
  return function ($this$url, it) {
    var tmp0_safe_receiver = $cursor._v;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$url.o44_1.r3q('cursor', tmp0_safe_receiver);
    }
    $this$url.o44_1.r3q('limit', $itemsPerPage.toString());
    $block($this$url, $this$url);
    return Unit_instance;
  };
}
function $listTemplatesCOROUTINE$25(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b8j_1 = _this__u8e3s4;
}
protoOf($listTemplatesCOROUTINE$25).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 18;
          var tmp_0 = this;
          tmp_0.c8j_1 = this.b8j_1.z8k_1;
          this.n8_1 = 1;
          suspendResult = this.b8j_1.b8l(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.d8j_1 = suspendResult;
          this.e8j_1 = this.d8j_1 + '/schedule_templates';
          var tmp_1 = this;
          tmp_1.f8j_1 = Companion_getInstance_6().s8i_1;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.h8j_1 = this.c8j_1;
          this.i8j_1 = this.e8j_1;
          this.j8j_1 = this.f8j_1;
          var tmp_2 = this;
          tmp_2.k8j_1 = 100;
          var tmp_3 = this;
          tmp_3.l8j_1 = TemplateRemoteSource$listTemplates$lambda;
          this.m8j_1 = {_v: null};
          var tmp_4 = this;
          tmp_4.n8j_1 = ArrayList_init_$Create$();
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          var tmp_5 = this;
          tmp_5.p8j_1 = Companion_instance;
          var tmp_6 = this;
          tmp_6.q8j_1 = this.h8j_1.f6l_1;
          var tmp_7 = this;
          tmp_7.r8j_1 = buildV2Path(this.h8j_1, this.i8j_1);
          this.s8j_1 = this.q8j_1;
          this.t8j_1 = this.r8j_1;
          var tmp_8 = this;
          tmp_8.u8j_1 = this.s8j_1;
          this.v8j_1 = this.u8j_1;
          var tmp_9 = this;
          tmp_9.w8j_1 = this.v8j_1;
          var tmp_10 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.t8j_1);
          headers(this_0, TemplateRemoteSource$listTemplates$lambda_0(this.j8j_1));
          this_0.z5n(TemplateRemoteSource$listTemplates$lambda_1(this.m8j_1, this.k8j_1, this.l8j_1));
          tmp_10.x8j_1 = this_0;
          this.y8j_1 = this.w8j_1;
          this.z8j_1 = this.x8j_1;
          this.z8j_1.q4r_1 = Companion_getInstance_0().f41_1;
          var tmp_11 = this;
          tmp_11.a8k_1 = this.y8j_1;
          var tmp_12 = this;
          tmp_12.b8k_1 = this.z8j_1;
          this.c8k_1 = this.a8k_1;
          this.d8k_1 = this.b8k_1;
          this.n8_1 = 4;
          suspendResult = (new HttpStatement(this.d8k_1, this.c8k_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.e8k_1 = suspendResult;
          var tmp_13 = this;
          this.p8j_1;
          var value = this.e8k_1;
          tmp_13.o8j_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 18;
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.o8_1 = 18;
          var tmp_14 = this.q8_1;
          if (tmp_14 instanceof CancellationException) {
            this.f8k_1 = this.q8_1;
            var tmp_15 = this;
            throw this.f8k_1;
          } else {
            var tmp_16 = this.q8_1;
            if (tmp_16 instanceof Error) {
              this.g8k_1 = this.q8_1;
              var tmp_17 = this;
              var exception = this.g8k_1;
              tmp_17.o8j_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 6;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 6:
          this.o8_1 = 18;
          this.h8k_1 = this.o8j_1;
          this.i8k_1 = this.h8k_1;
          this.j8k_1 = Result__exceptionOrNull_impl_p6xea9(this.i8k_1);
          if (this.j8k_1 == null) {
            var tmp_18 = this;
            var tmp_19 = _Result___get_value__impl__bjfvqg(this.i8k_1);
            tmp_18.l8k_1 = (tmp_19 == null ? true : !(tmp_19 == null)) ? tmp_19 : THROW_CCE();
            this.m8k_1 = this.l8k_1;
            var tmp_20 = this;
            tmp_20.n8k_1 = this.m8k_1;
            this.o8k_1 = this.n8k_1;
            this.p8k_1 = this.o8k_1.c4u().z43_1;
            var containsArg = this.p8k_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 11;
              var tmp_21 = this;
              tmp_21.s8k_1 = Companion_instance;
              if (getKClass(ApiPaginatedResponse).equals(getKClass(Unit))) {
                var tmp_22 = this;
                tmp_22.u8k_1 = this.o8k_1;
                this.v8k_1 = this.u8k_1;
                this.n8_1 = 9;
                var tmp_23 = this.v8k_1.y4u();
                var tmp_24 = getKClass(ApiPaginatedResponse);
                var tmp_25;
                try {
                  tmp_25 = createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiTemplate), arrayOf([]), false))]), false);
                } catch ($p) {
                  var tmp_26;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_26 = null;
                  } else {
                    throw $p;
                  }
                  tmp_25 = tmp_26;
                }
                suspendResult = tmp_23.a4u(new TypeInfo(tmp_24, tmp_25), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_27 = this;
                tmp_27.w8k_1 = this.o8k_1;
                this.x8k_1 = this.w8k_1;
                this.n8_1 = 8;
                var tmp_28 = this.x8k_1.y4u();
                var tmp_29 = getKClass(JsonElement);
                var tmp_30;
                try {
                  tmp_30 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_31;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_31 = null;
                  } else {
                    throw $p;
                  }
                  tmp_30 = tmp_31;
                }
                suspendResult = tmp_28.a4u(new TypeInfo(tmp_29, tmp_30), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_32 = this;
              tmp_32.y8k_1 = Companion_instance;
              this.n8_1 = 7;
              suspendResult = mapApiErrorResponse(this.o8k_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_33 = this;
            var it = this.j8k_1;
            var exception_0 = Companion_instance_0.b2u(it);
            tmp_33.k8k_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 14;
            continue $sm;
          }

        case 7:
          var tmp4 = suspendResult;
          var tmp_34 = this;
          this.y8k_1;
          tmp_34.q8k_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 13;
          continue $sm;
        case 8:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_35 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiPaginatedResponse), arrayOf([createInvariantKTypeProjection(createKType(getKClass(ApiTemplate), arrayOf([]), false))]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_36;
            if (tmp2 instanceof JsonObject) {
              tmp_36 = tmp2.c3p('data');
            } else {
              tmp_36 = false;
            }
            if (tmp_36) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_37;
              if (dataValue instanceof JsonObject) {
                tmp_37 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_37 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_37 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_37;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_35.t8k_1 = tmp$ret$0;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          var tmp_38 = this;
          tmp_38.t8k_1 = suspendResult instanceof ApiPaginatedResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 10;
          continue $sm;
        case 10:
          var tmp1 = this.t8k_1;
          var tmp_39 = this;
          this.s8k_1;
          tmp_39.r8k_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 18;
          this.n8_1 = 12;
          continue $sm;
        case 11:
          this.o8_1 = 18;
          var tmp_40 = this.q8_1;
          if (tmp_40 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_41 = this;
            throw e_0;
          } else {
            var tmp_42 = this.q8_1;
            if (tmp_42 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_43 = this;
              tmp_43.r8k_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 12;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 12:
          this.o8_1 = 18;
          var tmp_44 = this;
          var this_2 = this.r8k_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_45;
          if (exception_1 == null) {
            var tmp_46 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_46 == null ? true : !(tmp_46 == null)) ? tmp_46 : THROW_CCE();
            tmp_45 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_45 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_44.q8k_1 = tmp_45.ul_1;
          this.n8_1 = 13;
          continue $sm;
        case 13:
          this.k8k_1 = new Result(this.q8k_1);
          this.n8_1 = 14;
          continue $sm;
        case 14:
          var result = this.k8k_1.ul_1;
          var WHEN_RESULT;
          if (_Result___get_isFailure__impl__jpiriv(result)) {
            var tmp_47 = this;
            var tmp0_elvis_lhs = Result__exceptionOrNull_impl_p6xea9(result);
            var exception_3 = tmp0_elvis_lhs == null ? new Unknown() : tmp0_elvis_lhs;
            tmp_47.g8j_1 = _Result___init__impl__xyqfz8(createFailure(exception_3));
            this.n8_1 = 17;
            continue $sm;
          } else {
            var tmp_48;
            if (_Result___get_isFailure__impl__jpiriv(result)) {
              tmp_48 = null;
            } else {
              var tmp_49 = _Result___get_value__impl__bjfvqg(result);
              tmp_48 = (tmp_49 == null ? true : !(tmp_49 == null)) ? tmp_49 : THROW_CCE();
            }
            var paginatedResponse = tmp_48;
            var tmp2_safe_receiver = paginatedResponse == null ? null : paginatedResponse.o6m_1;
            var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.b6m_1;
            this.m8j_1._v = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g6m_1;
            var tmp5_safe_receiver = paginatedResponse == null ? null : paginatedResponse.n6m_1;
            var tmp_50;
            if (tmp5_safe_receiver == null) {
              tmp_50 = null;
            } else {
              tmp_50 = this.n8j_1.n(tmp5_safe_receiver);
            }
            WHEN_RESULT = tmp_50;
            this.n8_1 = 15;
            continue $sm;
          }

        case 15:
          if (!(this.m8j_1._v == null)) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 16;
          continue $sm;
        case 16:
          var tmp_51 = this;
          var value_1 = this.n8j_1;
          tmp_51.g8j_1 = _Result___init__impl__xyqfz8(value_1);
          if (false) {
            this.n8_1 = 2;
            continue $sm;
          }

          this.n8_1 = 17;
          continue $sm;
        case 17:
          return new Result(this.g8j_1);
        case 18:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 18) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function $getBasePathCOROUTINE$26(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.k8l_1 = _this__u8e3s4;
}
protoOf($getBasePathCOROUTINE$26).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.k8l_1.a8l_1.e2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var ARGUMENT = suspendResult;
          var ARGUMENT_0 = ARGUMENT.toString();
          return 'company/' + ARGUMENT_0;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function TemplateRemoteSource(apiClient, sessionDataProvider) {
  Companion_getInstance_6();
  this.z8k_1 = apiClient;
  this.a8l_1 = sessionDataProvider;
}
protoOf(TemplateRemoteSource).a8f = function ($completion) {
  var tmp = new $listTemplatesCOROUTINE$25(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
protoOf(TemplateRemoteSource).b8l = function ($completion) {
  var tmp = new $getBasePathCOROUTINE$26(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function get_schedulingModule() {
  _init_properties_SchedulingModule_kt__q88klc();
  return schedulingModule;
}
var schedulingModule;
function schedulingModule$lambda($this$module) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = schedulingModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(ISchedulingRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = schedulingModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(ISchedulingMutator), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = schedulingModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(ICustomShiftFlagRemoteSource), null, tmp2_1, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp10 = new TypeQualifier(getKClass(CustomShiftFlag));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = schedulingModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IListLocalSource), tmp10, definition, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = schedulingModule$lambda$lambda_3;
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Singleton_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(CustomShiftFlagRepository), null, definition_0, kind_3, secondaryTypes_3);
  var factory_3 = new SingleInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_3);
  }
  var tmp = new KoinDefinition($this$module, factory_3);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$21 = [getKClass(ICustomShiftFlagAccessor), getKClass(ICustomShiftFlagMutator)];
  binds(tmp, tmp$ret$21);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = schedulingModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(ITemplateRemoteSource), null, tmp2_2, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.qualifier.named' call
  var tmp22 = new TypeQualifier(getKClass(Template));
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = schedulingModule$lambda$lambda_5;
  var scopeQualifier_5 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Singleton_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(IListLocalSource), tmp22, definition_1, kind_5, secondaryTypes_5);
  var factory_5 = new SingleInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_5);
  }
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = schedulingModule$lambda$lambda_6;
  var scopeQualifier_6 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Singleton_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(TemplateRepository), null, definition_2, kind_6, secondaryTypes_6);
  var factory_6 = new SingleInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_6);
  }
  var tmp_0 = new KoinDefinition($this$module, factory_6);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$35 = [getKClass(ITemplateMutator), getKClass(ITemplateAccessor)];
  binds(tmp_0, tmp$ret$35);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = schedulingModule$lambda$lambda_7;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_7 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_7 = Kind_Factory_getInstance();
  var secondaryTypes_7 = emptyList();
  var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(ITemplateCompositeAccessor), null, tmp2_3, kind_7, secondaryTypes_7);
  var factory_7 = new FactoryInstanceFactory(def_7);
  $this$module.p1c(factory_7);
  new KoinDefinition($this$module, factory_7);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_4 = schedulingModule$lambda$lambda_8;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_8 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_8 = Kind_Factory_getInstance();
  var secondaryTypes_8 = emptyList();
  var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(IScheduleWarningRemoteSource), null, tmp2_4, kind_8, secondaryTypes_8);
  var factory_8 = new FactoryInstanceFactory(def_8);
  $this$module.p1c(factory_8);
  new KoinDefinition($this$module, factory_8);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_3 = schedulingModule$lambda$lambda_9;
  var scopeQualifier_9 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_9 = Kind_Singleton_getInstance();
  var secondaryTypes_9 = emptyList();
  var def_9 = new BeanDefinition(scopeQualifier_9, getKClass(ScheduleWarningRepository), null, definition_3, kind_9, secondaryTypes_9);
  var factory_9 = new SingleInstanceFactory(def_9);
  $this$module.p1c(factory_9);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_9);
  }
  var tmp_1 = new KoinDefinition($this$module, factory_9);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$49 = [getKClass(IScheduleWarningAccessor)];
  binds(tmp_1, tmp$ret$49);
  return Unit_instance;
}
function schedulingModule$lambda$lambda($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new SchedulingRemoteSource(tmp, tmp$ret$1);
}
function schedulingModule$lambda$lambda_0($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(ISchedulingRemoteSource), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(IShiftInvalidator), null, null);
  return new SchedulingRepository(tmp, tmp_0, tmp$ret$2);
}
function schedulingModule$lambda$lambda_1($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new CustomShiftFlagRemoteSource(tmp, tmp$ret$1);
}
function schedulingModule$lambda$lambda_2($this$single, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('custom_shift_flags', tmp$ret$0);
}
function schedulingModule$lambda$lambda_3($this$single, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(ICustomShiftFlagRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(CustomShiftFlag));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new CustomShiftFlagRepository(tmp, tmp$ret$2);
}
function schedulingModule$lambda$lambda_4($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new TemplateRemoteSource(tmp, tmp$ret$1);
}
function schedulingModule$lambda$lambda_5($this$single, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(ICache), null, null);
  return new SimpleListCacheLocalSource('templates', tmp$ret$0);
}
function schedulingModule$lambda$lambda_6($this$single, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(ITemplateRemoteSource), null, null);
  // Inline function 'org.koin.core.qualifier.named' call
  // Inline function 'org.koin.core.scope.Scope.get' call
  var qualifier = new TypeQualifier(getKClass(Template));
  var tmp$ret$2 = $this$single.q1d(getKClass(IListLocalSource), qualifier, null);
  return new TemplateRepository(tmp, tmp$ret$2);
}
function schedulingModule$lambda$lambda_7($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITemplateAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IDepartmentAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(ILocationAccessor), null, null);
  return new TemplateCompositeService(tmp, tmp_0, tmp$ret$2);
}
function schedulingModule$lambda$lambda_8($this$factory, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(Client), null, null);
  return new ScheduleWarningRemoteSource(tmp$ret$0);
}
function schedulingModule$lambda$lambda_9($this$single, it) {
  _init_properties_SchedulingModule_kt__q88klc();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(IScheduleWarningRemoteSource), null, null);
  return new ScheduleWarningRepository(tmp$ret$0);
}
var properties_initialized_SchedulingModule_kt_h0iu76;
function _init_properties_SchedulingModule_kt__q88klc() {
  if (!properties_initialized_SchedulingModule_kt_h0iu76) {
    properties_initialized_SchedulingModule_kt_h0iu76 = true;
    schedulingModule = module_0(VOID, schedulingModule$lambda);
  }
}
function ITemplateAccessor() {
}
function ITemplateCompositeAccessor() {
}
function Template(id, locationId, departmentId, name) {
  this.x8f_1 = id;
  this.y8f_1 = locationId;
  this.z8f_1 = departmentId;
  this.a8g_1 = name;
}
protoOf(Template).toString = function () {
  return 'Template(id=' + this.x8f_1.toString() + ', locationId=' + this.y8f_1.toString() + ', departmentId=' + toString(this.z8f_1) + ', name=' + this.a8g_1 + ')';
};
protoOf(Template).hashCode = function () {
  var result = this.x8f_1.hashCode();
  result = imul(result, 31) + this.y8f_1.hashCode() | 0;
  result = imul(result, 31) + (this.z8f_1 == null ? 0 : this.z8f_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.a8g_1) | 0;
  return result;
};
protoOf(Template).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Template))
    return false;
  var tmp0_other_with_cast = other instanceof Template ? other : THROW_CCE();
  if (!this.x8f_1.equals(tmp0_other_with_cast.x8f_1))
    return false;
  if (!this.y8f_1.equals(tmp0_other_with_cast.y8f_1))
    return false;
  if (!equals(this.z8f_1, tmp0_other_with_cast.z8f_1))
    return false;
  if (!(this.a8g_1 === tmp0_other_with_cast.a8g_1))
    return false;
  return true;
};
function ISchedulingMutator() {
}
function ITemplateMutator() {
}
function TemplateCompositeService(templateAccessor, departmentAccessor, locationAccessor) {
  this.l8l_1 = templateAccessor;
  this.m8l_1 = departmentAccessor;
  this.n8l_1 = locationAccessor;
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_1 = new Companion();
Companion_instance_2 = new Companion_0();
//endregion
//region block: exports
export {
  get_schedulingModule as get_schedulingModule3koantibgbov5,
  ITemplateAccessor as ITemplateAccessor9ycvy56ntkeh,
  ITemplateCompositeAccessor as ITemplateCompositeAccessor3fjc7lkze0e6v,
  ISchedulingMutator as ISchedulingMutator2o3geodc2adgx,
  ITemplateMutator as ITemplateMutator2hgxu9b9sapxu,
};
//endregion

